import * as THREE from 'three';

/** Environnement « studio » : softbox, strips latéraux, murs avant/arrière sombres.
 *  Donne des reflets propres sur métal et verre, sans fichier HDR à charger. */
export function studioEnvironment(renderer, opts = {}) {
  const room = new THREE.Scene();
  room.add(new THREE.Mesh(new THREE.BoxGeometry(14, 14, 14),
    new THREE.MeshBasicMaterial({ color: opts.roomColor ?? 0xa3a7ae, side: THREE.BackSide })));
  const add = (w, h, k, pos, color = 0xffffff) => {
    const m = new THREE.Mesh(new THREE.PlaneGeometry(w, h),
      new THREE.MeshBasicMaterial({ color: new THREE.Color(color).multiplyScalar(k), side: THREE.DoubleSide }));
    m.position.set(...pos); m.lookAt(0, 0, 0); room.add(m);
  };
  [[0, 0, 6.9], [0, 0, -6.9]].forEach(p => add(14, 9, 1, p, opts.wallColor ?? 0x16171a));
  add(7, 7, 3.4, [0, 6.5, 0]);                 // softbox plafond
  add(1.4, 8, 6.0, [-6.5, 0.6, 2]);            // strip gauche
  add(1.4, 8, 4.5, [6.5, 0.6, -2]);            // strip droite
  add(3, 2, 1.8, [4.5, 3.5, 5]);               // fill avant
  add(3, 2, 1.6, [-4.5, 3.5, -5]);             // fill arrière
  add(8, 1.2, 3.5, [0, -0.8, -6.8], 0xdde7ff); // liseré froid
  add(14, 5, 0.7, [0, -6.8, 0], 0xe6dfd4);     // rebond sol
  const pm = new THREE.PMREMGenerator(renderer);
  const tex = pm.fromScene(room, 0.015).texture;
  pm.dispose();
  return tex;
}

/** Ombre de contact douce (plan + dégradé radial). */
export function contactShadow() {
  const c = document.createElement('canvas'); c.width = c.height = 256;
  const g = c.getContext('2d');
  const gr = g.createRadialGradient(128, 128, 0, 128, 128, 128);
  gr.addColorStop(0, 'rgba(0,0,0,.32)'); gr.addColorStop(.6, 'rgba(0,0,0,.08)'); gr.addColorStop(1, 'rgba(0,0,0,0)');
  g.fillStyle = gr; g.fillRect(0, 0, 256, 256);
  const m = new THREE.Mesh(new THREE.PlaneGeometry(1, 1),
    new THREE.MeshBasicMaterial({ map: new THREE.CanvasTexture(c), transparent: true, depthWrite: false }));
  m.rotation.x = -Math.PI / 2;
  return m;
}

/** Applique l'environnement à tous les matériaux d'un objet (envMapIntensity reste effectif). */
export function applyEnv(root, env) {
  root.traverse(o => {
    if (!o.isMesh) return;
    (Array.isArray(o.material) ? o.material : [o.material]).forEach(m => {
      if (m && 'envMap' in m && !m.isMeshBasicMaterial && !m.envMap) { m.envMap = env; m.needsUpdate = true; }
    });
  });
}
